<template>
  <div>
    <div
      v-if="label || $slots.secondary"
      class="flex items-end"
      :class="label ? 'justify-between' : 'justify-end'"
    >
      <InputLabel
        v-if="label"
        :for="name"
        :iui="{ label: ui?.label }"
      >
        {{ label }}
      </InputLabel>
      <slot name="secondary" />
    </div>
    <div :class="{ 'mt-2': label || $slots.secondary }">
      <slot />
    </div>
    <div
      v-if="description || errors"
      class="mt-2.5 space-y-1.5"
    >
      <div
        v-show="errors"
        class="text-xs text-red-600"
      >
        <template v-if="errors?.includes('email the file to content.team@approachguides.com')">
          {{ errors.split("email the file to content.team@approachguides.com")[0] }}
          <a
            href="mailto:content.team@approachguides.com?subject=Please%20help%20me%20with%20my%20image&body=I%20just%20tried%20to%20upload%20this%20image%20%E2%80%94%20I've%20attached%20it%20to%20this%20email%20%E2%80%94%20but%20the%20file%20format%20isn't%20accepted.%20Can%20you%20help%20me%3F%20Thank%20you!"
            class="font-medium text-red-600 underline hover:text-red-700"
          >email us</a>
          with the file
          {{ errors.split("email the file to content.team@approachguides.com")[1] }}
        </template>
        <template v-else-if="errors">
          {{ errors }}
        </template>
      </div>
      <div
        v-show="description"
        class="text-xs text-supplement"
      >
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ClassValue } from 'clsx'

const props = defineProps<{
  name: string
  label?: string
  description?: string
  ui?: Partial<{
    label: ClassValue
  }>
}>()

const { getFieldErrors } = injectStrict<ProvideForm>('form')
const errors = getFieldErrors(props.name)
</script>
